<template>
    <div class="contnedor_calendario">
        <div class="picker-header">
            <button type="button" @click="previousWeek()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="picker-header-arrow"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 19l-7-7 7-7"
                    />
                </svg>
            </button>

            <h2>
                {{ calculateMes() }}
            </h2>
            <button type="button" @click="nextWeek()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="picker-header-arrow"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 5l7 7-7 7"
                    />
                </svg>
            </button>
        </div>

        <div
            class="calendario"
            :style="` grid-template-columns: ${
                semana.length == 1 ? 13 : 9
            }% repeat(${semana.length}, ${
                semana.length == 1 ? 87 : 91 / semana.length
            }% [col-start]);`"
        >
            <div style="border-bottom: 1px solid rgb(216, 216, 216)"></div>
            <div class="dias" v-for="(dia, index) in semana" :key="index">
                <div
                    class="titulo"
                    style="border-bottom: 1px solid rgb(216, 216, 216)"
                >
                    <div class="dia" v-if="semana.length == 1">
                        {{ dia_str }}
                    </div>
                    <div class="dia" v-else>
                        {{ dias[index] }}
                    </div>
                    <div class="dia amountButton-0">
                        {{ dia.split("-")[2] }}
                    </div>
                </div>
            </div>
            <template v-for="(hora, index) in horas">
                <div class="time date-container">
                    {{ hora | hora_formated }}
                </div>
                <template v-for="(dia, index) in semana">
                    <div
                        class="cita date-container"
                        :data-hora="hora"
                        :data-dia="dia"
                    >
                        <template v-for="(elemento, index) in seguimientos">
                            <template v-if="elemento.fecha == dia">
                                <router-link
                                    v-if="elemento.hora == hora"
                                    :to="{
                                        path: `/guardar-cliente?id=${elemento.id_cliente}`,
                                    }"
                                    class="action-buttons"
                                >
                                    <div data-draggable="true" draggable="true">
                                        <div
                                            class="dias__visita"
                                            :style="`background-color:${getColor(
                                                elemento
                                            )}`"
                                            :key="index"
                                            @click=""
                                        >
                                            <div
                                                style="
                                                    border-bottom: 1px solid
                                                        rgb(216, 216, 216);
                                                    width: 100%;
                                                    text-align: center;
                                                    padding-bottom: 0.25rem;
                                                "
                                            >
                                                <div
                                                    style="
                                                        display: flex;
                                                        align-items: center;
                                                        justify-content: space-evenly;
                                                    "
                                                >
                                                    <span>{{
                                                        elemento.cliente
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div>
                                                {{ elemento.observacion }}
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </template>
                        </template>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<style>
.date-container {
    border-bottom: 1px solid rgb(216, 216, 216);
}
.time {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    min-height: 2rem;
}
.warning-icon {
    width: 1.5rem;
}
.amountButton-0 {
    min-width: none;
    display: flex;

    align-items: center;
    justify-content: center;
    border-radius: 1rem;
    background-color: #b4b4b4;
}
.dia {
    font-weight: bold;
    font-family: "Roboto", sans-serif !important;

    text-align: center;
    margin: 0.75rem;

    padding: 0.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.picker-header-arrow {
    color: gray;
    width: 2rem;
}
.picker-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem;
}
.contnedor_calendario {
    border-radius: 0.5rem;
    margin-top: 1rem;
    border: 1px solid #dddddd;
}
.cita {
    display: flex;
    flex-direction: column;
}
.calendario {
    overflow-x: auto;
    width: 100%;
    display: grid;
}

.header {
    display: flex;
    justify-content: center;
    padding: 0.5rem;
}

.mes__titulo {
    text-align: center;
    padding: 0.5rem;
    color: #868ba1;
}
.titulo {
    display: flex;
    flex-direction: column;
}
.dias {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.dias__titulos,
.dias__fecha {
    padding: 0.5rem;
    background-color: #0866c6;
    color: white;
    text-align: center;
}

.dias__visita {
    flex-direction: column;
    min-width: none;
    display: flex;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    padding: 0.25rem;
    align-items: center;
    justify-content: center;
    border-radius: 1rem;
    background-color: #343434;
    color: white;
    min-width: 85%;
    min-height: 2rem;
}
</style>

<script>
export default {
    props: ["value", "fecha"],

    created() {
        this.getMobile();

        this.getWeek(true);
        // this.generateHoras();

        window.addEventListener("resize", this.getWidth);
    },

    destroyed() {
        window.removeEventListener("resize", this.getWidth);
    },
    watch: {
        fecha: function (val) {
            this.currentDate = val;
            this.getWeek(false);
        },
        currentDate: function (val) {
            this.getWeek(false);
        },
        value: function (val) {
            this.seguimientos = val;
            this.generateHoras();
            this.getWeek(false);
        },
        // seguimientos: function(val){
        //     this.$emit('input', val);
        // }
    },
    filters: {
        hora_formated(val) {
            // Convertir la parte entera en horas
            const horas = Math.floor(val);
            // Convertir la parte decimal en minutos
            const minutos = Math.round((val - horas) * 60);
            // Formatear el resultado para que siempre tenga dos dígitos (ej: 08:05)
            return `${horas.toString().padStart(2, "0")}:${minutos
                .toString()
                .padStart(2, "0")}`;
        },
    },

    methods: {
        getWidth() {
            this.getMobile();
            if (this.isMobileView & (this.semana.length > 1)) {
                this.getWeek(true);
            }
            if (!this.isMobileView & (this.semana.length == 1)) {
                this.getWeek(true);
            }
        },
        SaveSeguimiento() {
            axios.post("api/save-seguimiento", this.seguimiento).then(
                (res) => {
                    this.$toast.sucs("Seguimiento guardado con éxito");
                    this.seguimiento = {};
                    this.getSeguimientos();
                },
                (err) => {
                    this.$custom_error("Error guardando el seguimiento");
                }
            );
        },
        allowDrop(ev) {
            ev.preventDefault();
        },
        drag(ev, elemento) {
            this.seguimiento = elemento;
            this.draggin = ev.target;
        },
        drop(ev, dia, hora) {
            ev.preventDefault();
            var seguimiento = this.seguimiento;
            seguimiento.fecha = dia;
            seguimiento.hora = hora;
            this.SaveSeguimiento(seguimiento);
            //ev.target.appendChild(this.draggin);
        },
        getColor(item) {
            //343434 negro
            //verde 4caf50
            //fb8c00 naranja
            if (item.proyecto) {
                if (item.proyecto.estado_id == 2) {
                    return "#4caf50";
                } else {
                    if (item.proyecto.usuario.role == 4) {
                        return "#fb8c00";
                    } else {
                        return "#343434";
                    }
                }
            }
            return "#343434";
        },
        generateHoras() {
            const horas = [];

            for (let i = 8; i <= 19; i++) {
                horas.push(i);
            }

            // Agregar horas específicas de los eventos
            this.seguimientos.forEach((seguimiento) => {
                const eventHour = parseFloat(seguimiento.hora);
                if (!horas.includes(eventHour)) {
                    horas.push(parseFloat(eventHour));
                }
            });

            // Ordenar las horas
            horas.sort((a, b) => a - b);

            this.horas = horas;
        },
        calculateMes() {
            return this.meses[
                parseInt((this.semana[0] ?? "0-1-0").split("-")[1]) - 1
            ];
        },
        //BOTONES DE MOVER SEMANA
        nextWeek() {
            let cantidad = 7;
            if (this.isMobileView) cantidad = 1;
            if (typeof this.currentDate == "string") {
                this.currentDate = new Date(this.currentDate);
            }
            this.currentDate.setDate(this.currentDate.getDate() + cantidad);
            this.getWeek(true);
        },

        previousWeek() {
            let cantidad = 7;
            if (this.isMobileView) cantidad = 1;
            this.currentDate.setDate(this.currentDate.getDate() - cantidad);
            this.getWeek(true);
        },
        getSeguimientos() {
            /*this.$emit(
                "getSeguimientos",
                `?fecha_inicio=${this.semana[0]}${
                    this.semana[6] != null ? `&fecha_fin=${this.semana[6]}` : ""
                }`
            );*/
            this.$emit("getSeguimientos", {
                fecha_inicio: this.semana[0],
                fecha_fin: this.semana[6],
            });
        },
        getMobile() {
            this.isMobileView = window.innerWidth <= 768; // Adjust the breakpoint as needed
        },
        //OBTENER SEMANA ACTUAL
        getWeek(seguimiento) {
            var week = new Array();
            let currentDate = new Date(this.currentDate);
            // Starting Monday not Sunday

            currentDate.setDate(
                currentDate.getDate() - currentDate.getDay() + 1
            );
            if (this.isMobileView) {
                week.push(
                    new Date(this.currentDate).toISOString().split("T")[0]
                );
                const weekdays = [
                    "Domingo",
                    "Lunes",
                    "Martes",
                    "Miércoles",
                    "Jueves",
                    "Viernes",
                    "Sábado",
                ];
                const date = new Date(this.currentDate);
                const dayOfWeek = date.getDay();

                this.dia_str = weekdays[dayOfWeek];
            } else {
                let finde = [];
                for (var i = 0; i < 7; i++) {
                    const date = new Date(currentDate)
                        .toISOString()
                        .split("T")[0];
                    if (i == 5 || i == 7) {
                        finde.push(date);
                    }
                    week.push(date);
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                let found = false;
                finde.forEach((dia) => {
                    this.value.forEach((elemento) => {
                        if (elemento.fecha == dia) {
                            found = true;
                        }
                    });
                });
                if (!found) {
                    week.pop();
                    week.pop();
                }
            }
            this.semana = week;
            if (seguimiento) {
                this.getSeguimientos();
            }
        },
        touchMove(ev, elemento) {
            this.seguimiento = elemento;
            ev.preventDefault();
            var touch = ev.touches[0];

            this.draggin = null;
            let par = ev.target;
            while (par.getAttribute("data-draggable") != "true") {
                par = par.parentElement;
            }
            // Set the position of the draggable element
            const cli_wi = par.clientWidth;
            par.style.position = "fixed";
            //   par.style.width = par.clientWidth + "px";
            par.style.left = touch.pageX - par.offsetWidth / 2 + "px";
            par.style.top = touch.pageY - par.offsetHeight - 10 + "px";
            //par.style.right = touch.pageX + 99 + "px";
        },

        touchEnd(ev, dia, hora) {
            ev.preventDefault();

            let par = ev.target;
            while (par.getAttribute("data-draggable") != "true") {
                par = par.parentElement;
            }
            par.style.zIndex = -1;

            if (this.seguimiento == null) return;
            const touchEndTarget = document.elementFromPoint(
                ev.changedTouches[0].clientX,
                ev.changedTouches[0].clientY
            );
            if (touchEndTarget == null) return;
            //console.log();
            var seguimiento = this.seguimiento;
            seguimiento.fecha = touchEndTarget.getAttribute("data-dia");
            seguimiento.hora = touchEndTarget.getAttribute("data-hora");
            this.SaveSeguimiento(seguimiento);
            this.seguimiento = null;
        },
    },
    computed: {
        //
    },
    data() {
        return {
            seguimientos: [],
            num_dias: 7,
            show_dias: 5,
            isMobileView: false,
            draggin: null,
            horas: [],
            meses: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ],
            semana: [],
            seguimiento: {},
            dias: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
            currentDate: new Date(),
            dia_str: "",
            mes: "",
        };
    },
};
</script>
